<po-page-list
  #poPageList
  p-title="Documenta.AI"
  [p-actions]="pageActions"
  [p-filter]="filter"
  [p-disclaimer-group]="disclaimerGroup"
  [class.documenta-ai-filter-disabled]="filterDisabled"
>
  <po-info *ngIf="errorMessage" p-label="" [p-value]="errorMessage"> </po-info>

  <po-table
    p-container="border"
    p-height="500"
    [p-columns]="columns"
    [p-items]="filteredItems"
    [p-actions]="tableActions"
    [p-actions-right]="true"
    [p-loading]="loading || exporting"
    [p-literals]="tableLiterals"
    [p-loading-show-more]="loadingShowMore"
    [p-show-more-disabled]="showMoreDisabled"
    [class.documenta-ai-columns-manager-disabled]="filterDisabled"
    (p-show-more)="loadMore()"
    p-striped
    p-sort
  ></po-table>

  <div class="documenta-ai-table-footer" *ngIf="subtitle">
    <span>{{ subtitle }}</span>
  </div>
</po-page-list>

<po-modal
  #advancedFilterModal
  p-title="Busca avançada"
  p-size="sm"
  [p-primary-action]="advancedFilterApplyAction"
  [p-secondary-action]="advancedFilterCancelAction"
  p-click-out="false"
>
  <div class="po-row">
    <po-input
      class="po-md-12"
      name="advUsername"
      p-label="Usuário"
      p-placeholder="ex.: joao.silva@totvs.com.br"
      [(ngModel)]="advancedFilters.username"
      p-clean
    >
    </po-input>
  </div>
  <div class="po-row">
    <po-input
      class="po-md-12"
      name="advIssueKey"
      p-label="Issue"
      p-placeholder="ex.: DSERFISE-13290"
      [(ngModel)]="advancedFilters.issueKey"
      p-clean
    >
    </po-input>
  </div>
  <div class="po-row">
    <po-datepicker
      class="po-md-6"
      name="advFromDate"
      p-label="De"
      p-placeholder="dd/mm/aaaa"
      [(ngModel)]="advancedFilters.fromDate"
      p-clean
    >
    </po-datepicker>
    <po-datepicker
      class="po-md-6"
      name="advToDate"
      p-label="Até"
      p-placeholder="dd/mm/aaaa"
      [(ngModel)]="advancedFilters.toDate"
      p-clean
    >
    </po-datepicker>
  </div>
</po-modal>

<po-modal
  #traceLogModal
  p-title="Log"
  p-size="lg"
  p-click-out="true"
  (p-close)="closeTraceLog()"
>
  <ng-container *ngIf="selectedTraceLogItem">
    <po-info
      class="po-md-3"
      p-label="Usuário"
      [p-value]="selectedTraceLogItem.email || selectedTraceLogItem.username"
    ></po-info>
    <po-info
      class="po-md-3"
      p-label="Issue"
      [p-value]="selectedTraceLogItem.issueKey || '-'"
    ></po-info>
    <po-info
      class="po-md-2"
      p-label="Data"
      [p-value]="selectedTraceLogItem.date | date: 'dd/MM/yyyy'"
    ></po-info>
    <po-info
      class="po-md-2"
      p-label="Horário"
      [p-value]="selectedTraceLogItem.time || '-'"
    ></po-info>
    <div class="po-md-2 po-info">
      <div class="po-info-container-title">
        <div class="po-info-label">Status</div>
      </div>
      <div class="po-info-value po-pt-1">
        <po-tag
          [p-value]="traceLogStatusLabel(selectedTraceLogItem.status)"
          [p-type]="traceLogStatusType(selectedTraceLogItem.status)"
          p-icon="true"
        ></po-tag>
      </div>
    </div>

    <po-code-editor
      class="po-md-12"
      [(ngModel)]="selectedTraceLogItem.traceLog"
      p-height="420"
      p-language="json"
      p-readonly="true"
      p-show-diff="false"
      p-theme="vs"
    ></po-code-editor>
  </ng-container>
</po-modal>
